/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from 'react';
import { useEnvStore } from '../env';
import { useLanguageStore } from '.';
import defaultLang from './en.json';
import { useAppStore } from '../app';

function useLangauge (p) {
    const language = useLanguageStore();
    const appStore = useAppStore();
    const [translations, setTranslations] = useState(language.translations || defaultLang);
    const [currentLocale, setLocale] = useState(appStore.locale || 'en');
    const env = useEnvStore();

    useEffect(() => {
        setLocale(appStore.locale);
        setTranslations(language.translations);
     }, [language.observed.translations]);
     
    function getLocaleLang () {
        let locale = appStore.locale || 'en';
        if ( appStore.widget?.language &&
            appStore.widget?.language !== 'auto') {
            locale = appStore.widget?.language;
        }
        return locale;
    }

    return {
        translations,
        currentLocale,
        getLocaleLang,
    };
}

export default useLangauge;